import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    address_label_main_screen_text: {
      id: 'address_label_main_screen_text',
      defaultMessage: "Address",
      description: '',
    },
    safetech_popup_add_profile: {
      id: 'safetech_popup_add_profile',
      defaultMessage: "Add new profile",
      description: '',
    },
    safetech_popup_add_profile_value: {
      id: 'safetech_popup_add_profile_value',
      defaultMessage: "New profile name",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/SafeTechPopup/Messages.js